import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";

export default function Terms() {
  const { t } = useTranslation();

  const sections = t("termsPage.sections", { returnObjects: true }) as Array<{
    title: string;
    content: string[];
  }>;

  return (
    <>
        <section className="bg-background">
          <div className="container py-16 md:py-20">
            <div className="mx-auto max-w-3xl">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border/60 bg-background/80 px-4 py-1.5 text-sm text-muted-foreground">
                <FileText className="h-4 w-4" />
                {t("termsPage.badge")}
              </div>
              <h1 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
                {t("termsPage.title")}
              </h1>
              <p className="mt-4 text-muted-foreground">
                {t("termsPage.lastUpdated")}
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-muted">
          <div className="container">
            <div className="mx-auto max-w-3xl space-y-10">
              {sections.map((section, index) => (
                <div key={index}>
                  <h2 className="text-xl font-semibold text-foreground mb-4">
                    {section.title}
                  </h2>
                  <div className="space-y-3">
                    {section.content.map((paragraph, pIndex) => (
                      <p key={pIndex} className="text-muted-foreground leading-relaxed">
                        {paragraph}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
    </>
  );
}
